/* tslint:disable */
/* eslint-disable */
/**
 * AIS Coverage API
 * API for managing AIS source identifiers and calculating coverage.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoverageImagePostRequest
 */
export interface CoverageImagePostRequest {
    /**
     * ID of the source identifier.
     * @type {number}
     * @memberof CoverageImagePostRequest
     */
    sourceIdentifierId: number;
    /**
     * Time range for coverage calculation
     * @type {string}
     * @memberof CoverageImagePostRequest
     */
    tsRange: string;
}

/**
 * Check if a given object implements the CoverageImagePostRequest interface.
 */
export function instanceOfCoverageImagePostRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sourceIdentifierId" in value;
    isInstance = isInstance && "tsRange" in value;

    return isInstance;
}

export function CoverageImagePostRequestFromJSON(json: any): CoverageImagePostRequest {
    return CoverageImagePostRequestFromJSONTyped(json, false);
}

export function CoverageImagePostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoverageImagePostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceIdentifierId': json['source_identifier_id'],
        'tsRange': json['ts_range'],
    };
}

export function CoverageImagePostRequestToJSON(value?: CoverageImagePostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_identifier_id': value.sourceIdentifierId,
        'ts_range': value.tsRange,
    };
}

